function LoadingBasic() {
  return (
    <div class='loading-basic-container'>
      <p>Loading ...</p>
    </div>
  );
}

export default LoadingBasic;